<template>
  <refonte-button
    variant="secondary"
    v-bind:on_click="props.cancel">
    Annuler
  </refonte-button>
  <refonte-button
    v-bind:disabled="props.submit_disabled"
    v-bind:on_click="props.submit">
    Lancer la procédure
  </refonte-button>
</template>

<script setup lang="ts">
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';

  const props = withDefaults(
    defineProps<{
      cancel?: Function;
      submit?: Function;
      submit_disabled?: boolean;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
